require('sass/blocks/personal-data-view.scss');
//@vendors
const React = require('react');
const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
// @ components
const { ProfileInvestmentPlan } = require('components/newAccountSteps/profileSteps/profileInvestmentPlan');
const { ProfileInvestmentPlanGBI } = require('components/newAccountSteps/profileSteps/profileInvestmentPlanGBI');
const WelcomeCard = require('components/welcomeCard/welcomeCard').welcomeCard;
//@actions
const stepsActions = require('actions/stepsActions');
// @ constants
const { ROBO } = require('constants/userProfile');

class InvestmentPlanView extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { userProfile } = this.props;

        const content = userProfile.investmentType === ROBO ? <ProfileInvestmentPlan /> : <ProfileInvestmentPlanGBI />;

        return (
            <div className="profesional-data-view">
                {content}
                <WelcomeCard />
            </div>
        );
    }
}

module.exports.constructor = InvestmentPlanView;
module.exports.InvestmentPlanView = connect(
    state => ({
        userProfile: state.userProfile,
        immStepsState: state.steps,
        immErrorState: state.error,
        products: state.products,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
    })
)(InvestmentPlanView);
